// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './polyfill'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import Vuelidate from 'vuelidate'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
//import Vuex from 'vuex'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import { router } from '@/router'
import ImageUploader from 'vue-image-upload-resize'
import Snotify from 'vue-snotify';
import Loading from 'vue-loading-overlay';
//import VueSimpleSuggest from 'vue-simple-suggest/dist/es7'
import VueSimpleSuggest from 'vue-simple-suggest';
import 'vue-simple-suggest/dist/styles.css';
import VueMeta from 'vue-meta';
import store from './store'

import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

// todo
// cssVars()
import 'vue-snotify/styles/material.css';
import 'vue-loading-overlay/dist/vue-loading.css';


import '@progress/kendo-theme-default/dist/all.css'
import { Grid } from '@progress/kendo-vue-grid';
import VueMask from 'v-mask';
import JsonCSV from 'vue-json-csv'
Vue.component('downloadCsv', JsonCSV);
Vue.component('Grid', Grid);
Vue.use(Vuelidate)
Vue.use(BootstrapVue);
Vue.use(ImageUploader);
Vue.use(Loading);
Vue.use(VueSimpleSuggest);
Vue.use(datePicker);
Vue.use(Snotify, {
  toast: {
    timeout: 4000
  }
});
Vue.use(require('vue-moment'));
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
});
Vue.use(VueMask);
//Vue.use(Vuex);

// load and register shared components
const requireComponent = require.context('./shared/components', false, /[A-Z]\w+\.(vue|js)$/)
requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName);
  const componentName = upperFirst(camelCase(fileName.split('/').pop().replace(/\.\w+$/, '')))
  Vue.component(componentName, componentConfig.default || componentConfig);
});

// load and register shared directives
const requireDirective = require.context('./shared/directives', false, /[a-z]\w+\.js$/i)
requireDirective.keys().forEach(fileName => requireDirective(fileName));

/* eslint-disable no-new */
let vm = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})

export default vm;
